// UI-only value: the SDK and stored llm_model always receive the canonical model ID.
export const GEMINI_38_VERTEX_OPTION = 'gemini-3.8-live@vertex';

export const liveModelSelection = (model: string, backend: unknown): string =>
  model === 'gemini-3.8-live' && backend === 'vertex' ? GEMINI_38_VERTEX_OPTION : model;

export const parseLiveModelSelection = (selection: string) => ({
  model: selection === GEMINI_38_VERTEX_OPTION ? 'gemini-3.8-live' : selection,
  backend: selection === GEMINI_38_VERTEX_OPTION ? ('vertex' as const) : undefined,
});
